import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { TreeNodeModel } from "../../models/category-new/category-tree-node";

interface CategoryMobileDropdownProps {
  categoriesData: TreeNodeModel[];
  selectedKeys: any;
  setSelectedKeys: (keys: any) => void;
  topCategorySelect?: (category: TreeNodeModel) => void;
}

const CategoryMobileDropdown: React.FC<CategoryMobileDropdownProps> = ({
  categoriesData,
  selectedKeys,
  setSelectedKeys,
  topCategorySelect,
}) => {
  const [selectedCategory, setSelectedCategory] = useState<TreeNodeModel | null>(
    null
  );

  const flattenCategories = (
    categories: TreeNodeModel[],
    level = 0
  ): TreeNodeModel[] => {
    let flattened: TreeNodeModel[] = [];

    categories.forEach((cat) => {
      flattened.push(cat);
      if (cat.children && cat.children.length > 0) {
        flattened = flattened.concat(flattenCategories(cat.children, level + 1));
      }
    });

    return flattened;
  };

  const flatCategories = flattenCategories(categoriesData);

  const categoryOptionTemplate = (option: any) => {
    if (!option) return "";
    
    // Count level by finding depth in hierarchy
    let level = 0;
    const findLevel = (cats: TreeNodeModel[], target: TreeNodeModel): number => {
      for (let cat of cats) {
        if (cat.key === target.key) return 0;
        if (cat.children) {
          const childLevel = findLevel(cat.children, target);
          if (childLevel !== -1) return childLevel + 1;
        }
      }
      return -1;
    };

    level = findLevel(categoriesData, option);
    if (level === -1) level = 0;

    const indent = "  ".repeat(Math.max(0, level));
    return (
      <div className="category-dropdown-item">
        <span>{indent}</span>
        <span>{option.label}</span>
      </div>
    );
  };

  const handleCategoryChange = (e: any) => {
    const selected = e.value;
    setSelectedCategory(selected);

    // Handle clear action (when selected is null)
    if (!selected) {
      setSelectedKeys({});
      return;
    }

    if (selected && selected.key) {
      const initFilterState: any = {
        [selected.key]: { checked: true, partialChecked: false },
      };
      
      // Include all children
      if (selected.children && selected.children.length > 0) {
        selected.children.forEach((child: TreeNodeModel) => {
          initFilterState[child.key] = { checked: true, partialChecked: false };
        });
      }

      setSelectedKeys(initFilterState);

      if (topCategorySelect) {
        topCategorySelect(selected);
      }
    }
  };

  const handleClear = () => {
    setSelectedCategory(null);
    setSelectedKeys({});
  };

  return (
    <div className="category-mobile-dropdown-wrapper">
      <Dropdown
        value={selectedCategory}
        onChange={handleCategoryChange}
        options={flatCategories}
        placeholder="Select Category"
        className="w-full category-mobile-dropdown"
        itemTemplate={categoryOptionTemplate}
        valueTemplate={(option) => {
          if (!option) return <span className="text-gray-500">All Categories</span>;
          return <span>{option.label}</span>;
        }}
        showClear
        filter
        filterBy="label"
      />
    </div>
  );
};

export default CategoryMobileDropdown;
